/*
 * App bootstrap. In dev mode we lazy-import the MSW worker so the
 * shipped production bundle never pulls it in.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { ToastProvider } from "@/components/toast/ToastProvider";
import { App } from "./App";

import "./styles/tokens.css";
import "./styles/base.css";

const qc = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5_000,
      refetchOnWindowFocus: false,
      retry: 0,
    },
    mutations: {
      retry: 0,
    },
  },
});

async function bootstrap(): Promise<void> {
  if (import.meta.env.DEV) {
    const { worker } = await import("./mocks/browser");
    await worker.start({ onUnhandledRequest: "bypass" });
  }
  const rootEl = document.getElementById("root");
  if (!rootEl) throw new Error("#root element missing");
  createRoot(rootEl).render(
    <StrictMode>
      <QueryClientProvider client={qc}>
        <BrowserRouter>
          <ToastProvider>
            <App />
          </ToastProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </StrictMode>,
  );
}

void bootstrap();
